import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss']
})
export class TemplatesComponent implements OnInit {
  activeTemplateTab: 'email' | 'checkout' | 'product' | 'medical' = 'email';
  medicalHistoryTabVisited = false;

  constructor() { }

  ngOnInit(): void {
  }

  selectTemplateTab(tab: 'email' | 'checkout' | 'product' | 'medical'): void {
    this.activeTemplateTab = tab;

    if (tab === 'medical') {
      this.medicalHistoryTabVisited = true;
    }
  }

}
